var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    rx: 3.5,
    fill: "#00B8D9",
    stroke: "#00B8D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8169 7.17822C14.9341 7.29238 15 7.44718 15 7.60859C15 7.77 14.9341 7.9248 14.8169 8.03895L8.87472 13.8218C8.75743 13.9359 8.59836 14 8.4325 14C8.26664 14 8.10758 13.9359 7.99028 13.8218L5.17558 11.0825C5.06164 10.9677 4.9986 10.814 5.00002 10.6544C5.00145 10.4948 5.06723 10.3421 5.1832 10.2292C5.29917 10.1164 5.45605 10.0524 5.62005 10.051C5.78405 10.0496 5.94205 10.1109 6.06002 10.2218L8.4325 12.5307L13.9324 7.17822C14.0497 7.06411 14.2088 7 14.3746 7C14.5405 7 14.6996 7.06411 14.8169 7.17822Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.b8c2eacccad61271f23a0ae78534e636.svg";
export { ForwardRef as ReactComponent };